export default "__VITE_ASSET__pdf$v9vD__"